import React from 'react';
import Text from '@rexlabs/text';

const Label = (props) => <Text is='span' {...props} type={['LABEL']} />;
export default Label;
